import { SignInPageComponent } from '@seen/react'
import type { JSX } from 'react'
import { useCallback } from 'react'
import { useNavigate } from 'react-router'
import { MEDPLUM_GOOGLE_CLIENT_ID, MEDPLUM_PROJECT_ID } from '#src/config.ts'

export const RETURN_URL_KEY = 'seen_return_url'

export function SignInPage(): JSX.Element {
  const navigate = useNavigate()

  const handleSignIn = useCallback(() => {
    const raw = localStorage.getItem(RETURN_URL_KEY)
    localStorage.removeItem(RETURN_URL_KEY)

    if (raw) {
      try {
        const { url, ts } = JSON.parse(raw)
        const FIFTEEN_MIN = 15 * 60 * 1000
        if (
          Date.now() - ts < FIFTEEN_MIN &&
          url.startsWith('/') &&
          !url.startsWith('//')
        ) {
          void navigate(url)
          return
        }
      } catch (error) {
        console.error('Failed to parse return URL from localStorage:', error)
      }
    }

    void navigate('/')
  }, [navigate])

  return (
    <SignInPageComponent
      medplumProjectId={MEDPLUM_PROJECT_ID}
      medplumGoogleClientId={MEDPLUM_GOOGLE_CLIENT_ID}
      onSignIn={handleSignIn}
      disableEmailAuth={false}
    />
  )
}
